import classnames from 'classnames';
import { isString } from 'lodash';

function getClassWithModifiers(base, modifiers) {
  if (isString(base)) {
    const baseTrimed = base.trim();

    return [
      baseTrimed,
      ...modifiers.map(modifier => {
        if (isString(modifier)) {
          const modifierTrimed = modifier.trim();
          return classnames({
            [`${baseTrimed}--${modifierTrimed}`]: baseTrimed && modifierTrimed,
          });
        }
      }),
    ]
      .join(' ')
      .trim();
  }
  return '';
}

const getClassModuler = moduleName => className => {
  return `${moduleName}-${className}`;
};

export { getClassWithModifiers, getClassModuler };
